window.addEventListener('load', () => {
    function isOutOfViewport(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        return (
            rect.bottom < 0 ||
            rect.top > windowHeight ||
            rect.right < 0 ||
            rect.left > windowWidth
        )
    }
    function toggleStickyBar() {
        const productButtons = document.querySelector('.rocket-product-info__buy-buttons')
        const stickyBar = document.querySelector('.section-product-sticky-bar')    
        if (!productButtons || !stickyBar) return;
        if (isOutOfViewport(productButtons)) {
        stickyBar.classList.add('is-sticky')
        } else {
        stickyBar.classList.remove('is-sticky')
        }
    }
    function handleAddToCartSticky() {
        const btnSubmit = document.querySelector('.btn-sticky-add-to-cart')
        if (btnSubmit) {
          btnSubmit.addEventListener('click', async function(btn) {
            if (btn.currentTarget.classList.contains('soldout')) {
              return
            }
            const form = document.querySelector('.rocket-buy-buttons-mobile form');
            const quantityInput = form.querySelector('input[name="quantity"]');
            if(quantityInput){
              quantityInput.value = document.querySelector('.product-form__input quantity-input .quantity__input').value || 1
            }
            if (form) {
                form.submit();
            }
          })
        }
    }
    handleAddToCartSticky()
    window.addEventListener('scroll', toggleStickyBar)
    toggleStickyBar()
})
class StickyVariantSelector {
    constructor() {
      this.init();
    }
  
    /**
      * Initializes the event listeners and setups up the initial state when the document is ready.
      */
    init() {
      document.addEventListener('DOMContentLoaded', () => {
        this.addToCartButton = document.querySelector('.product-form-mobile__submit');
        this.variantIdInput = document.querySelector('.product-variant-id.sticky-mobile');
        this.selectElement = document.querySelector('.product-form__variant-picker');
        this.sizeOptions = document.querySelector('.sticky-size-options');
        this.stickyOption = document.querySelectorAll('.sticky-option');
        this.variantColor = document.querySelectorAll('.variant-option--color');
        this.priceElement = document.getElementById("selected-price");
        this.body = document.body;
        this.setupEventListeners();
        this.setupClickOutsideListeners();
      });
    }
  
    /**
      * Sets up event listeners for the variant select element and its options.
      */
    setupEventListeners() {
      if (this.selectElement) {
        this.selectElement.addEventListener('click', () => {
          const header = document.querySelector(".section-header.shopify-section-group-header-group")
          if(header){
            header.style.zIndex = 5
          }
          this.selectElement.classList.toggle('active');
          this.sizeOptions.classList.toggle('active');
          this.body.classList.toggle('select-sizes-active');
        });
      }
  
      if (this.stickyOption) {
        this.stickyOption.forEach(option => {
          option.addEventListener('click', () => this.handleOptionClick(option));
        });
      }
    }
  
    /**
      * Handles click events on each variant option.
      * @param {HTMLElement} option - The option element that was clicked.
      */
    handleOptionClick(option) {
      const id = option.getAttribute("value");
      const sizeName = option.querySelector(".sticky-title").textContent.trim();
      const price = option.getAttribute("data-price");
      const sizeValue = option.getAttribute("size-value");
      const _form = option.closest("form");
      const form_id = _form.querySelector('input[name="id"]');
      form_id.value = id;
      const sizeTriggerButton = document.querySelector(".sticky-select__trigger.button-primary");
      if (sizeTriggerButton) {
          sizeTriggerButton.textContent = sizeName;
      }
      let priceNeedUpdateSticky = document.getElementById("selected-price");
      if(priceNeedUpdateSticky){
        priceNeedUpdateSticky.innerHTML = price
      }
      const variantInput = document.getElementById("quantity-stock_inventory")
      if(variantInput){
        variantInput.value = id
        variantInput.setAttribute("data-value", id);
      }
      const variantSizes = document.querySelectorAll('variant-radios .product-form__input input');
      if (variantSizes.length > 0) {
        variantSizes.forEach((variantSize) => {
          if (!variantSize.closest('.product-form__input').classList.contains('option-type-color')) {
            if (variantSize.value === sizeValue) {
              variantSize.checked = true;
            } else {
              variantSize.checked = false;
            }
          }
        });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', form_id.value);
      window.history.replaceState({}, '', url.toString());
      // if (this.priceElement && price) {
      //   this.priceElement.innerHTML = price;
      // }
      this.closeDropdowns();
    }
  
    /**
      * Sets up click outside event listeners for specified elements.
      */
    setupClickOutsideListeners() {
      document.addEventListener('click', (event) => {
        const header = document.querySelector(".section-header.shopify-section-group-header-group")
        if(!this.sizeOptions){
          return
        }
        if(header && !this.sizeOptions.classList.contains("active")){
          header.style.zIndex = 9
        }
        if(this.selectElement) {
            if (!this.selectElement?.contains(event.target) && !this.sizeOptions?.contains(event.target)) {
                this.closeDropdowns();
            }
        }
      });
    }
  
    /**
      * Closes dropdown elements by removing 'active' class if they are open.
      */
    closeDropdowns() {
      if (this.selectElement.classList.contains('active')) {
        this.selectElement.classList.remove('active');
        this.sizeOptions.classList.remove('active');
        this.body.classList.remove('select-sizes-active');
      }
    }
  }
  
  new StickyVariantSelector();
  